// Test_server
// const baseurl = "http://122.186.126.218:8089/api";
// Sathish_server
// const baseurl = "http://172.31.13.191:8000/api";
const baseurl = "https://apiinvoice.uds.in/api";
// const baseurl = "http://192.168.5.234:9005/api";
// const baseurl = "http://122.186.126.218:8089/api";

// const baseurl = "http://192.168.1.28:9004/api";
// const baseurl = "http://192.168.1.24:9003/api";
// const baseurl = "http://192.168.1.24:8000/api";

//-----------------Login
export const loginapi = baseurl + "/login/";
//-----------------forgotOTPSent
export const forgotOTPSentApi = baseurl + "/forget_otp/";
//-----------------VerifyOTP
export const verifyOTPSentApi = baseurl + "/verify_otp/";
//-----------------VerifyOTP
export const resetPasswordApi = baseurl + "/password_update/";
// --------Plant List
export const plantlist = baseurl + "/plantlist/";
// --------Plant List
// export const plantProjects = baseurl + "/plantprojects/";
export const plantProjects = baseurl + "/plantprojectslist/";
// --------File List
export const fileList = baseurl + "/filelist/";
// --------Plant Create
export const plantCreate = baseurl + "/plant_creation/";
// --------Project Create
export const projectCreate = baseurl + "/project_creation/";
// --------Project WBS Create
export const projectWbsCreate = baseurl + "/project_wbs_creation/";
// --------Project WBS Create
export const projectWbsFetch = baseurl + "/projectwbslist/";
// --------Schedule Create
export const scheduleCreate = baseurl + "/createproject/";

// export const scheduledget = baseurl + "/schedule_list/";
export const scheduledget = baseurl + "/scheduledetails/";

export const invoiceget = baseurl + "/sentdetails/";

export const new_invoice = baseurl + "/new_sentdetails/";

export const plant_drop = baseurl + "/plantlist_drop/";
export const project_drop = baseurl + "/plantprojectslist_drop/";
export const projectwbs_drop = baseurl + "/projectwbslist_drop/";

export const usergetdata = baseurl + "/user/";

export const commoncreation = baseurl + "/common_creation/";

export const filedownload = baseurl + "/ftpfileview/";

export const exceldatadownloadapi = baseurl + "/sentxls/";
export const newexceldatadownloadapi = baseurl + "/new_sentxls/";
export const invoiceAmount = baseurl + "/invoice_amount/";
export const exportAmountsApi = baseurl + "/export/amounts/";
